import { Button, Drawer } from "antd";
import UsersTable from "../components/UsersTable/UsersTable";
import { useState } from "react";
import { UserAddOutlined } from "@ant-design/icons";
import AjouterUserForm from "../components/AjouterUserForm.tsx/AjouterUserForm";

function UsersPage() {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px 10px",
        }}
      >
        <Button
          size="small"
          variant="filled"
          color="default"
          onClick={showDrawer}
        >
          <UserAddOutlined />
          Ajouter
        </Button>
      </div>
      <UsersTable />
      <Drawer
        title="Ajouter un utilisateur"
        placement={"right"}
        closable={true}
        onClose={onClose}
        open={open}
        width={600}
        key={1}
      >
        <AjouterUserForm onClose={onClose} />
      </Drawer>
    </div>
  );
}

export default UsersPage;
